import { RcFile } from 'antd/es/upload';

import { IMessaging } from '../../hook/useSubscribe';

export interface IRcFileManage extends RcFile {
  response?: IUploadResponses;
}

export interface IManageUploadStatus {
  progressId: string;
  fileId: string;
  filename: string;
}

export interface AttachmentsFile {
  id: string;
  name: string;
  originalName: string;
  extension: string;
  relativePath: string;
  url: string;
  size: number;
}

export interface IUploadResponses {
  category: string;
  extension: string;
  id: string;
  name: string;
  objectId: string;
  originalName: string;
  progressId: string;
  status: string;
  uploadedBy: string;
  size: number;
  relativePath: string;
  url: string;
}

export enum UploadStatus {
  UploadFailed = 'UploadFailed',
  Uploading = 'Uploading',
  Uploaded = 'Uploaded',
}

export interface IUploadAttachment {
  id?: string;
  isOpen: boolean;
  onClose: () => void;
  onFinished: (values: AttachmentsFile[]) => void;
  remainFiles?: number;
  existedFileNames: string[];
  category: string;
  loading?: boolean;
}

export interface IUploadResponses {
  category: string;
  extension: string;
  id: string;
  name: string;
  objectId: string;
  originalName: string;
  progressId: string;
  status: string;
  uploadedBy: string;
  size: number;
  relativePath: string;
  url: string;
}

export interface IFileRendering {
  file: IRcFileManage;
  removeFile: (value: IRcFileManage) => void;
  message?: IMessaging;
  messageOriginal?: string;
  callbackOnDone?: (
    fileId?: string,
    fileName?: string,
    progressId?: string
  ) => void;
  callbackOnError?: (
    fileId?: string,
    fileName?: string,
    progressId?: string
  ) => void;
}
